module.exports = __webpack_public_path__ + "img/square.9a74af0b.svg";